const ProfilePage = () => import('./profilePage.vue');

export default [
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage
  }
];
